export const handleIncompleteRegistration = (details, navigate, migration = false) => {
  if (migration) sessionStorage.setItem("migration", "true");
  sessionStorage.setItem("registerData", JSON.stringify(details));

  if (details?.schufaVerified === false) {
    navigate("/verify/schufa");
  } else if (details?.mobilePhoneVerified === false) {
    navigate("/verify/phone");
  } else if (details?.passwordSet === false) {
    navigate("/register/set-password");
  } else {
    navigate("/confirm");
  }
};
